(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["moonlights-rating-line"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-moonlights-random-count]').forEach((element) => {
    if (element.dataset.ready === 'true') return;
    element.dataset.ready = 'true';
    const min = Number.parseInt((element.dataset.min || '').replace(/,/g, ''), 10);
    const max = Number.parseInt((element.dataset.max || '').replace(/,/g, ''), 10);
    if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) return;
    const value = Math.floor(Math.random() * (max - min + 1)) + min;
    element.textContent = value.toLocaleString('en-US');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["moonlights-size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.moonlights-size-chart__button');
    if (trigger) {
      const chart = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!chart) return;
      chart.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      chart.querySelector('.moonlights-size-chart__panel')?.focus();
      return;
    }

    const close = event.target.closest('.moonlights-size-chart__close');
    const overlay = event.target.classList?.contains('moonlights-size-chart__overlay') ? event.target : close?.closest('.moonlights-size-chart__overlay');
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.moonlights-size-chart__overlay:not([hidden])').forEach((overlay) => {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
